import React from "react";
import { Search } from "lucide-react";

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
}

const ACCENT = "var(--accent, #8B5CF6)";

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, icon }) => {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-[30px] text-center">
      <div
        className="mb-3.5 grid h-12 w-12 place-items-center rounded-xl"
        style={{ background: `color-mix(in srgb, ${ACCENT} 12%, transparent)`, color: ACCENT }}
      >
        {icon || <Search className="h-[22px] w-[22px]" />}
      </div>
      <h4 className="mb-1 text-sm font-semibold text-og01-text">{title}</h4>
      <p className="max-w-xs text-xs text-og01-text-muted">{description}</p>
    </div>
  );
};

export default EmptyState;
